/* Veloramode – Quiet luxury UI (header, carrousels, hero, nieuwsbriefbalk) */
(function () {
  'use strict';
  if (window.__qlUi) return;
  window.__qlUi = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function store(key, val) {
    try { if (val === undefined) return localStorage.getItem(key); localStorage.setItem(key, val); } catch (e) { return null; }
  }

  /* ---------- Menu-drawer ---------- */
  function initMenu() {
    var drawer = $('[data-ql-menu]');
    if (!drawer || drawer.__ql) return;
    drawer.__ql = true;
    var opener = $('[data-ql-menu-open]');
    var lastFocus = null;
    function open() {
      lastFocus = document.activeElement;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (opener) opener.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      var first = drawer.querySelector('button, a');
      if (first) setTimeout(function () { first.focus(); }, 50);
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (opener) opener.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }
    if (opener) opener.addEventListener('click', open);
    $$('[data-ql-menu-close]', drawer).forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });
  }

  /* ---------- Zoeken ---------- */
  function initSearch() {
    var btn = $('[data-ql-search-toggle]');
    var box = $('#QlSearch');
    if (!btn || !box || btn.__ql) return;
    btn.__ql = true;
    btn.addEventListener('click', function () {
      var show = box.hasAttribute('hidden');
      if (show) box.removeAttribute('hidden'); else box.setAttribute('hidden', '');
      btn.setAttribute('aria-expanded', String(show));
      if (show) { var i = box.querySelector('input[type="search"]'); if (i) i.focus(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !box.hasAttribute('hidden')) { box.setAttribute('hidden', ''); btn.setAttribute('aria-expanded', 'false'); btn.focus(); }
    });
  }

  /* ---------- Winkeltas-teller ---------- */
  var countTimer = null;
  function refreshCount() {
    clearTimeout(countTimer);
    countTimer = setTimeout(function () {
      fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          $$('[data-ql-cart-count]').forEach(function (el) {
            el.textContent = cart.item_count;
            if (cart.item_count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
          });
        }).catch(function () {});
    }, 150);
  }
  window.qlRefreshCartCount = refreshCount;
  ['cart:updated', 'cart:build', 'cart:refresh', 'cart:change', 'ajaxProduct:added', 'theme:cart:change'].forEach(function (ev) {
    document.addEventListener(ev, refreshCount);
  });
  if (window.fetch && !window.__qlFetchWrap) {
    window.__qlFetchWrap = true;
    var of = window.fetch;
    window.fetch = function () {
      var a = arguments;
      var u = typeof a[0] === 'string' ? a[0] : (a[0] && a[0].url) || '';
      var p = of.apply(this, a);
      if (/\/cart\/(add|change|update|clear)/.test(u)) p.then(refreshCount).catch(function () {});
      return p;
    };
  }

  /* ---------- Carrousels: voortgangsbalk + tweede foto bij tap ---------- */
  function initTrack(section) {
    var track = $('[data-ql-track]', section);
    var bar = $('[data-ql-progress]', section);
    if (!track || track.__ql) return;
    track.__ql = true;
    function update() {
      if (!bar) return;
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 1) { bar.parentNode.style.visibility = 'hidden'; return; }
      bar.parentNode.style.visibility = '';
      var ratio = track.clientWidth / track.scrollWidth;
      var pos = track.scrollLeft / max;
      bar.style.width = (ratio * 100) + '%';
      bar.style.transform = 'translateX(' + (pos * (1 / ratio - 1) * 100) + '%)';
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initCards(ctx) {
    var touch = window.matchMedia && window.matchMedia('(hover: none)').matches;
    if (!touch) return;
    $$('[data-ql-card]', ctx).forEach(function (card) {
      if (card.__ql || !card.querySelector('.ql-card__alt')) return;
      card.__ql = true;
      var media = card.querySelector('.ql-card__media');
      var x0 = 0, moved = false;
      media.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; moved = false; }, { passive: true });
      media.addEventListener('touchmove', function (e) { if (Math.abs(e.touches[0].clientX - x0) > 8) moved = true; }, { passive: true });
      media.addEventListener('click', function (e) {
        if (moved) return;
        if (!card.classList.contains('is-alt')) { e.preventDefault(); card.classList.add('is-alt'); }
      });
    });
  }

  /* ---------- Aanbevelingen (Vaak samen gekocht / Bekijk ook) ---------- */
  function initReco(section) {
    var url = section.getAttribute('data-ql-reco');
    if (!url || section.__qlReco) return;
    section.__qlReco = true;
    function load(u, triedFallback) {
      fetch(u).then(function (r) { return r.text(); }).then(function (html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('[data-ql-carousel]');
        var track = fresh && fresh.querySelector('[data-ql-track]');
        if (!track || !track.children.length) {
          if (!triedFallback && /intent=complementary/.test(u)) { load(u.replace('intent=complementary', 'intent=related'), true); return; }
          section.remove(); return;
        }
        section.querySelector('[data-ql-track]').innerHTML = track.innerHTML;
        section.style.display = '';
        initTrack(section);
        initCards(section);
      }).catch(function () { section.remove(); });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { io.disconnect(); load(url); }
      }, { rootMargin: '600px 0px' });
      io.observe(section.parentNode || section);
    } else { load(url); }
  }

  /* ---------- Hero-slider ---------- */
  function initHero(hero) {
    if (hero.__ql) return;
    hero.__ql = true;
    var slides = $$('[data-ql-slide]', hero);
    var bars = $$('[data-ql-bar]', hero);
    if (slides.length < 2) return;
    var i = 0, timer = null;
    var speed = (parseFloat(getComputedStyle(hero).getPropertyValue('--ql-hero-speed')) || 6) * 1000;
    function go(n) {
      slides[i].classList.remove('is-active');
      slides[i].setAttribute('aria-hidden', 'true');
      $$('a', slides[i]).forEach(function (a) { a.setAttribute('tabindex', '-1'); });
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active');
      slides[i].removeAttribute('aria-hidden');
      $$('a', slides[i]).forEach(function (a) { a.removeAttribute('tabindex'); });
      bars.forEach(function (b, k) {
        b.classList.remove('is-active', 'is-done');
        void b.offsetWidth;
        if (k < i) b.classList.add('is-done');
        if (k === i) b.classList.add('is-active');
      });
      var v = slides[i].querySelector('video');
      if (v) { try { v.currentTime = 0; v.play(); } catch (e) {} }
      schedule();
    }
    function schedule() {
      clearTimeout(timer);
      if (reduceMotion || hero.classList.contains('is-paused')) return;
      timer = setTimeout(function () { go(i + 1); }, speed);
    }
    bars.forEach(function (b, k) { b.addEventListener('click', function () { go(k); }); });
    hero.addEventListener('mouseenter', function () { hero.classList.add('is-paused'); clearTimeout(timer); });
    hero.addEventListener('mouseleave', function () { hero.classList.remove('is-paused'); schedule(); });
    hero.addEventListener('focusin', function () { hero.classList.add('is-paused'); clearTimeout(timer); });
    hero.addEventListener('focusout', function () { hero.classList.remove('is-paused'); schedule(); });
    var x0 = null;
    hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
      x0 = null;
    });
    document.addEventListener('visibilitychange', function () { if (document.hidden) clearTimeout(timer); else schedule(); });
    schedule();
  }

  /* ---------- Subtiele nieuwsbriefbalk (na 20 s, geen pop-up) ---------- */
  function initNewsletterBar() {
    var bar = $('[data-ql-nbar]');
    if (!bar || bar.__ql) return;
    bar.__ql = true;
    var KEY = 'ql_nbar_closed';
    var done = bar.querySelector('[data-ql-nbar-done]');
    function show() {
      bar.removeAttribute('hidden');
      requestAnimationFrame(function () { bar.classList.add('is-open'); document.body.classList.add('ql-nbar-on'); });
    }
    function hide() {
      bar.classList.remove('is-open');
      document.body.classList.remove('ql-nbar-on');
      store(KEY, String(Date.now()));
      setTimeout(function () { bar.setAttribute('hidden', ''); }, 500);
    }
    var close = bar.querySelector('[data-ql-nbar-close]');
    if (close) close.addEventListener('click', hide);
    if (done) { show(); store(KEY, String(Date.now() + 1e11)); setTimeout(hide, 4000); return; }
    var last = parseInt(store(KEY) || '0', 10);
    if (last && Date.now() - last < 1000 * 60 * 60 * 24 * 14) return;
    if (window.Shopify && Shopify.designMode) return;
    var delay = (parseInt(bar.getAttribute('data-delay'), 10) || 20) * 1000;
    setTimeout(show, delay);
  }

  function init() {
    initMenu();
    initSearch();
    $$('[data-ql-carousel]').forEach(function (s) { initTrack(s); initReco(s); });
    initCards(document);
    $$('[data-ql-hero]').forEach(initHero);
    initNewsletterBar();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-ql-carousel]', e.target).forEach(function (s) { initTrack(s); initReco(s); });
    initCards(e.target);
    $$('[data-ql-hero]', e.target).forEach(initHero);
    initMenu(); initSearch(); initNewsletterBar();
  });
})();
